import { observer } from 'mobx-react-lite';

import { IcClose16Icon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { FAB } from '@gem/ui-kit';

import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';

import usePresenter from './presenter';
import styles from './styles.m.css';

const LinkPreview = () => {
  const presenter = usePresenter();

  if (!presenter.isShowLinkPreview) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.preview}>
        <AddKeyPressHandler onEsc={presenter.closePreview} />
        <MiniatureMessageLayout
          className={styles.previewContainer}
          titleClassName={styles.miniatureTitle}
          textClassName={styles.miniatureText}
          iconClassName={styles.miniatureIcon}
          imageUrl={presenter.linkPreviewData.image?.url}
          title={<p className={styles.title}>{presenter.linkPreviewData.domain}</p>}
          text={presenter.linkPreviewData.title}
          link={presenter.linkPreviewData.link}
        />
        <FAB
          Icon={IcClose16Icon}
          size="10"
          iconSize="0"
          theme="12"
          onClick={presenter.closePreview}
        />
      </div>
    </div>
  );
};

export default observer(LinkPreview);
